var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-100 -105 200 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star",
    fill: "black",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Classical Five-Point Star, by Adam Stanislav"), /*#__PURE__*/React.createElement("desc", null, "A star polygon, calculated and coded by hand to follow the classical star shape (sometimes called a concave decagon) traditionally constructed geometrically since antiquity."), /*#__PURE__*/React.createElement("path", {
    d: "m0-100l22.4514 69.0983 72.6543 0-58.7781 42.7051 22.4509 69.0983-58.7785-42.7051-58.7785 42.7051 22.4509-69.0983-58.7781-42.7051 72.6543 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.af15978ea2cb6e227f59949559b5780c.svg";
export { ForwardRef as ReactComponent };